import { FC, Suspense } from 'react';
import { lazily } from 'react-lazily';

import { AnnouncementsModalHandler } from '@bonusly/common-announcements';
import { GiveFeedbackFromTemplateModal, GlobalGiveUnrequestedFeedbackModal, GlobalRequestFeedbackModal, ViewFeedbackModal } from '@bonusly/common-feedback';
import { GlobalGiveBox } from '@bonusly/common-give-box';

import { BonusVideoRecordingModal } from '../components/video/recording/bonus-video-recording-modal';
import { GiveAwardModal } from '../modules/bonus-feed/features/recognition/components/Awards/GiveAwardModal';
import { useInitNominationModal } from '../modules/nominations/hooks';
import { NominationModal } from '../modules/nominations/nomination-modal';
import { ReviewSolicitationsModal, WelcomeModal } from './remote';

const { ClaimIncentive } = lazily(() => import('../modules/incentives/redeem/components/claim-incentive'));
const { App: InviteUsersModal } = lazily(() => import('../modules/invite-users-modal/components/app'));
const { CalendarEventsModal } = lazily(() => import('@bonusly/common-meeting-modal'));

export const GlobalModals: FC = () => {
	useInitNominationModal();

	return (
		<>
			<GlobalGiveBox />
			<BonusVideoRecordingModal />
			<GlobalGiveUnrequestedFeedbackModal />
			<GlobalRequestFeedbackModal />
			<ViewFeedbackModal />
			<GiveFeedbackFromTemplateModal />
			<WelcomeModal />
			<ReviewSolicitationsModal />
			<Suspense>
				<ClaimIncentive />
			</Suspense>
			<NominationModal />
			<GiveAwardModal />
			<AnnouncementsModalHandler />

			<Suspense>
				<InviteUsersModal />
			</Suspense>
			<Suspense>
				<CalendarEventsModal />
			</Suspense>
		</>
	);
};
